<template>
<div class="size mt-3 mb-1 "  @click='setCarSelected(carId)'>
 
		<figure class="card card-product-grid " >
            <TopBlurCardOfCar/>
         
                
			<a href="#" class="img-wrap "> 
                
				<img img :src="carImg" alt="" loading="lazy">
                
			</a>
            
			<figcaption class="info-wrap" >
                 <p href="#" class="brand-name">{{carBrand}}</p>
				<a href="#" class="price">{{carName}} {{carMotor}} {{carYear}}</a>
				<div class="mt-2">				
                </div> <!-- action-wrap.end -->
			</figcaption>
		</figure> <!-- card // -->
	</div> <!-- col.// -->
</template>

<script>
import {TopBlurCardOfCar} from './style'
import { mapActions } from 'vuex'
    export default {
        components: {
            TopBlurCardOfCar,
        },
        data() {
            return {
            }
        },
        props: {
            garageID: {
                type: Number,
            },
            carId: {
                type: Number,
            },
            carName: {
                type: String,
            },
            carBrand: {
                type: String,
            },
            carYear: {
                type: [Number, String],
            },
            carMotor: {
                type: String,
            },
            carImg: {
                type: String,
            },
        },
        methods: {
            ...mapActions('home', ['ActionSetCarSelectedLocalStorage','ActionSetGarageSelectedLocalStorage']),          
            async setCarSelected(id) {
                this.ActionSetCarSelectedLocalStorage(id)
                this.ActionSetGarageSelectedLocalStorage(this.garageID)
                this.$router.push({name:'product_car_list'})
                //const payload = {car:id}
                //await this.ActionSetCar(payload)
                //this.$router.push({ name: 'showParts', params: { id: id } })
            }
        },
    }
</script>

<style scoped>
.card {
position: relative;
display: flex;
flex-direction: column;
max-width: 22rem;
max-height: 17rem;
word-wrap: break-word;
background-color: #fff;
background-clip: border-box;
border: 0.019rem solid var(--main-red-black);
box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
border-radius: 1.6rem ;
cursor:pointer;

}
.blur {
position: absolute;
width: 100vw;
height: 100%;
left: 0;
top: 0;
background: linear-gradient(180deg, #3a3a3a 7.73%, rgba(196, 196, 196, 0) 35%);
}

.brand-name{

color:var(--main-black);
font-size: .82rem;
line-height: 1.2;

}

.img-wrap {
text-align: center;
display: contents;   
}

[class*='product-'] .img-wrap img {
height: 100%;
min-height: 7.55rem;
min-height: 10.55rem;
width: 70%;
display: inline-block;
-o-object-fit: cover;
object-fit: contain;
margin:auto;
}
.card-product-grid .info-wrap {
overflow: hidden;
padding: 6%;
}

.size {
flex: 0 0 75%;
max-width: 80%;
position: relative;
width: 100%;
padding-right: .5rem;
padding-left: .5rem;
}


  @media (min-width: 700px)  {
.size {
    flex: 0 0 17%;
    max-width: 50%;
    position: relative;
    width: 100%;
    min-width:20%;

    
}
   
  }
  @media (min-width: 1000px) {
.size {
    flex: 0 0 17%;
    max-width: 50%;
    position: relative;
    width: 100%;
    min-width:10%;

    
}
   
  }
</style>